import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { throwError } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private accessToken: string;
  public channelType: string;

  constructor(private http: HttpClient) { }

  setToken(token) {
    localStorage.setItem('access_token', token['access_token']);
  }

  getToken() {
    return this.accessToken;
  }

  getChannel() {
    const url = window.location.href;
    const find = url.indexOf('telecanal');
    if (find === -1) {
      this.channelType = 'WEB';
    } else {
      this.channelType = 'TELECANAL';
    }
  }

  getChannelId() {
    return this.channelType;
  }

  getTokenInit() {
    const userNameCrypto = CryptoJS.AES.encrypt(environment.username, "E546C8DF278CD593").toString();
    const passwordCrypto = CryptoJS.AES.encrypt(environment.password, "E546C8DF278CD593").toString();

    const data = {
      username: userNameCrypto,
      password: passwordCrypto
    };

    this.http.post(environment.APIEndpoint + environment.microservices.auth + 'auth/token-request', data).subscribe(
      (res: Response) => {
        localStorage.setItem('access_token', res['access_token']);
        // you can assign the value to any variable here
      }
    );
  }

  validateRouteToken() {
    return this.http.get('http://192.168.1.18:3000/auth2/token-validate');
  }

  getTokenRequired() {
    return !!localStorage.getItem('access_token');
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}

